import AccountSummaryPage from "components/pages/AccountSummaryPage";

export default function CaptureNotifiAccountSummary(props) {
    return <AccountSummaryPage />
}